// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateBrazilianPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!/^\d{8,}$/.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}
